
let serverUrl='http://192.168.70.23:8092'; //管理端地址 https://hqjdm.gxjzy.com http://192.168.70.23:8092
let MenHuUrl='http://jyhq.gxjzy.com';//门户网站地址
let CasHost='http://tysfcas.123xfw.com:88/cas/';//认证中心地址
let location=window.location.href;//当前url
let hostName=window.location.hostname;//获取主机名

/*if(location.indexOf('192.168')!=-1){
  serverUrl="http://"+hostName+":8092";
}*/

import axios from 'axios'
import Qs from 'qs'
export const HOST = "/api"
export const menHuUrl = MenHuUrl
export const casHost = CasHost
export const OK = 200;

//门户网站的单点登录

export function getUserInfoByToken(token) {
  const url = HOST + '/home/user/getUserInfoByToken'
  let data = {
    "token": token
  }
  return axios.post(url,Qs.stringify(data))
}





export function getUserInfoByTicket(token) {
  const url = HOST + '/home/user/getUserInfoByTicket'
  let data = {
    "token": token
  }
  return axios.post(url,Qs.stringify(data))
}
export function getUserInfoByValidateurl(validateurl) {
  const url = HOST + '/home/user/stuCasLogin'
  let data = {
    "validateurl": validateurl
  }
  return axios.post(url,Qs.stringify(data))
}

export function getAdminInfoByValidateurl(validateurl) {
  const url = HOST + '/home/user/adminCasLogin'
  let data = {
    "validateurl": validateurl
  }
  return axios.post(url,Qs.stringify(data))
}
export function getUserInfoByValidateurlPC(validateurl) {
  const url = HOST + '/home/user/stuCasLoginPC'
  let data = {
    "validateurl": validateurl
  }
  return axios.post(url,Qs.stringify(data))
}
/*export function getUserInfoByValidateurlPC(ticket,serviceUrl) {
  const url = HOST + '/home/user/stuCasLoginPC'
  let data = {
    "ticket": ticket,
    "serviceUrl": serviceUrl,
  }
  return axios.post(url,Qs.stringify(data))
}*/

//通过登录账号获取用户信息
export function pclogonSSO(username,ticket,timestamp) {
  const url = HOST + '/home/user/pclogonSSO'
  let data = {
    "username": username,
    "ticket": ticket,
    "timestamp": timestamp
  }
  return axios.post(url,Qs.stringify(data))
}

//通过登录账号获取用户信息
export function logonSSO(username,ticket,timestamp) {
  const url = HOST + '/home/user/logonSSO'
  let data = {
    "username": username,
    "ticket": ticket,
    "timestamp": timestamp
  }
  return axios.post(url,Qs.stringify(data))
}
//获取验证码（没有用该方法）
export function getVerifyCode() {
  const url = HOST + '/home/user/getVerifyCode'
  return axios.get(url,{responseType: "arraybuffer"})
}
//手机版登录
export function login(username,password) {
  const url = HOST + '/home/user/logon'
  let data = {
    "username": username,
    "password": password

  }
  return axios.post(url,Qs.stringify(data))
}
//pc端登录
export function pclogin(username,password) {
  const url = HOST + '/home/user/pclogin'
  let data = {
    "username": username,
    "password": password

  }
  return axios.post(url,Qs.stringify(data))
}

//管理员登录
export function adminLogon(username,password) {
  const url = HOST + '/home/operator/adminLogon'
  let data = {
    "username": username,
    "password": password
  }
  return axios.post(url,Qs.stringify(data))
}
//单点登录获取管理员信息
export function adminLoginSSO(username) {
  const url = HOST + '/home/operator/adminLoginSSO'
  let data = {
    "username": username

  }
  return axios.post(url,Qs.stringify(data))
}
//获取服务项目
export function getServiceItem() {
  const url = HOST + '/home/tieZi/getServiceItem'
  return axios.get(url)
}
//获取服务项目
export function getServiceItemByPid(pid) {
  const url = HOST + '/home/tieZi/getServiceItemByPid'
  let data = {
    "pid":pid
  }
  return axios.post(url,Qs.stringify(data))
}

//提交帖子
export function addTiezi(userId,userName,telPhone,tieziType,usertype,identity,serviceitemType,serviceitemId,title,distName,content,classNameOrDepartment,imagePath) {
  const url = HOST + '/home/user/addTiezi'
  let data = {
    "userId":userId,
    "userName":userName,
    "telPhone":telPhone,
    "tieziType":tieziType,
    "usertype":usertype,
    "sid":identity,//用户的登录账号
    "serviceitemType":serviceitemType,
    "serviceitemId":serviceitemId,
    "title":title,
    "distName":distName,
    "content":content,
    "classNameOrDepartment":classNameOrDepartment,
    "imagePath":imagePath,

  }
  return axios.post(url,Qs.stringify(data))
}

//根据userId获取帖子
export function getMyTieZiByUserId(userId) {
  let data = {
    "userId":userId,
  }
  const url = HOST + '/home/tieZi/getMyTieZi'
  return axios.post(url,Qs.stringify(data))
}


//根据id获取帖子
export function getMyTieZiById(id) {
  let data = {
    "id":id,
  }
  const url = HOST + '/home/tieZi/getMyTieZiById'
  return axios.post(url,Qs.stringify(data))
}

//帖子按照最新显示
export function getNewestTieZi() {

  const url = HOST + '/home/tieZi/getNewestTieZi'
  return axios.post(url)
}

//帖子按照最火显示
export function getPopularTieZi() {

  const url = HOST + '/home/tieZi/getPopularTieZi'
  return axios.post(url)
}

//动态按照最新显示
export function getInformation() {

  const url = HOST + '/home/tieZi/articleList'
  return axios.post(url)
}
//根据动态类型获取动态列表
export function getListByInfoTypeName(name) {
  let data = {
    "name":name,
  }
  const url = HOST + '/home/tieZi/getListByInfoTypeName'
  return axios.post(url,Qs.stringify(data))
}

//帖子按照点赞次数从大到小排列
export function getGreatTieZi() {

  const url = HOST + '/home/tieZi/getGreatTieZi'
  return axios.post(url)
}
//帖子按照具体的服务类型进行筛选
export function getByTieZiType(tieziType) {
  let data = {
    "tieziType":tieziType,
  }
  const url = HOST + '/home/tieZi/getByTieZiType'
  return axios.post(url,Qs.stringify(data))
}
//帖子按照具体的服务项目进行筛选（大类型的服务项目）
export function getByServiceItemType(serviceItemType) {
  let data = {
    "serviceItemType":serviceItemType,
  }
  const url = HOST + '/home/tieZi/getByServiceItemType'
  return axios.post(url,Qs.stringify(data))
}
//帖子按照具体的服务项目进行筛选（大类型的服务项目）
export function getByServiceItemName(name) {
  let data = {
    "name":name,
  }
  const url = HOST + '/home/tieZi/getByServiceItemName'
  return axios.post(url,Qs.stringify(data))
}
//帖子根据内容进行模糊查询帖子
export function getByLikeContent(keyword) {
  let data = {
    "keyword":keyword,
  }
  const url = HOST + '/home/tieZi/getByLikeContent'
  return axios.post(url,Qs.stringify(data))
}

//帖子根据标题或内容进行模糊查询帖子
export function getByLikeTitleOrContent(keyword) {
  let data = {
    "keyword":keyword,
  }
  const url = HOST + '/home/tieZi/getByLikeTitleOrContent'
  return axios.post(url,Qs.stringify(data))
}

//点赞点赞数加1；取消点赞，点赞数减1

export function getGreatCount(id,greatType) {
  let data = {
    "id":id,
    "greatType":greatType,
  }
  const url = HOST + '/home/tieZi/getGreatCount'
  return axios.post(url,Qs.stringify(data))
}

//浏览数加1
export function getBrowseCount(id) {
  let data = {
    "id":id
  }
  const url = HOST + '/home/tieZi/getBrowseCount'
  return axios.post(url,Qs.stringify(data))
}

//浏览数加1(动态信息)
export function getInfoBrowseCount(id) {
  let data = {
    "id":id
  }
  const url = HOST + '/home/tieZi/getInfoBrowseCount'
  return axios.post(url,Qs.stringify(data))
}
export function getInfoById(id) {
  let data = {
    "id":id
  }
  const url = HOST + '/home/tieZi/getInfoById'
  return axios.post(url,Qs.stringify(data))
}
//获取动态类型
export function getInfoType() {
  const url = HOST + '/home/tieZi/getInfoType'
  return axios.post(url)
}

//回复数量数加1
export function getReplyCount(id,replyCount) {
  let data = {
    "id":id,
    "replyCount":replyCount
  }
  const url = HOST + '/home/tieZi/getReplyCount'
  return axios.post(url,Qs.stringify(data))
}

//评论 点赞点赞数加1；取消点赞，点赞数减1
export function getCommentGreatCount(id,greatType) {
  let data = {
    "id":id,
    "greatType":greatType,
  }
  const url = HOST + '/home/comment/getCommentGreatCount'
  return axios.post(url,Qs.stringify(data))
}
//保存评论
export function addComment(tieZiId,userId,sid,type,content) {
  let data = {
    "tieZiId":tieZiId,
    "userId":userId,
    "sid":sid,//登录账号
    "type":type,//识别是否是是管理员
    "content":content
  }
  const url = HOST + '/home/comment/addComment'
  return axios.post(url,Qs.stringify(data))
}
//回复内容 回复帖子
export function addReplyContent(tieZiId,adminId,sid,content) {
  let data = {
    "tieZiId":tieZiId,
    "adminId":adminId,
    "sid":sid ,//登录账号
    "content":content
  }
  const url = HOST + '/home/comment/addReply'
  return axios.post(url,Qs.stringify(data))
}
//选择回复内容回复帖子
export function selectReplyContent(tieZiId,adminId,sid,id) {
  let data = {
    "tieZiId":tieZiId,
    "adminId":adminId,
    "sid":sid ,//登录账号
    "id":id
  }
  const url = HOST + '/home/comment/selectReplyContent'
  return axios.post(url,Qs.stringify(data))
}

//删除评论或者回复
export function delMobileCommentById(id,tieZiId,adminId) {
  let data = {
    "id":id,
    "tieZiId":tieZiId,
    "adminId":adminId,
  }
  const url = HOST + '/home/tieZi/delMobileCommentById'
  return axios.post(url,Qs.stringify(data))
}

//修改帖子标题
export function modifyTitleById(id,title) {
  let data = {
    "id":id,
    "title":title
  }
  const url = HOST + '/home/tieZi/modifyTitleById'
  return axios.post(url,Qs.stringify(data))
}
//修改帖子内容
export function modifyContentById(id,content) {
  let data = {
    "id":id,
    "content":content
  }
  const url = HOST + '/home/tieZi/modifyContentById'
  return axios.post(url,Qs.stringify(data))
}
//根据帖子id进行审核
export function censorPostById(id,adminName) {
  let data = {
    "id":id,
    "adminName":adminName
  }
  const url = HOST + '/home/tieZi/censorPostById'
  return axios.post(url,Qs.stringify(data))
}
//获取回复选择内容
export function replyContentList(){
  const url = HOST + '/home/tieZi/replyContentList'
  return axios.post(url)
}

//按照最新回复排列
export function getNewReply(tieZiId) {
  const url = HOST + '/home/comment/getNewReply'
  let data = {
    "tieZiId":tieZiId,
  }
  return axios.post(url,Qs.stringify(data))
}

//按照最早回复排列
export function getOldReply(tieZiId) {
  const url = HOST + '/home/comment/getOldReply'
  let data = {
    "tieZiId":tieZiId
  }
  return axios.post(url,Qs.stringify(data))
}

export function getTypelist() {
  const url = HOST + '/typelist'
  return axios.get(url)
}
//所有获取未审核的帖子

export function getUnCensorPostAll() {
  const url = HOST + '/home/tieZi/getUnCensorPostAll'
  return axios.post(url)
}
//获取未审核的帖子按照具体的服务类型进行筛选
export function getUnCensorPostByType(tieziType) {
  let data = {
    "tieziType":tieziType,
  }
  const url = HOST + '/home/tieZi/getUnCensorPostByType'
  return axios.post(url,Qs.stringify(data))

}

export function getwxConfig(strUrl) {
  const url = HOST + '/home/wxConfig'
  let data = {
    "strUrl": strUrl
  }
  return axios.post(url,Qs.stringify(data))
}


//pc端

//获取帖子列表
//{title=, type=0, status=-1, date=, author=, serviceItem=, page=1, size=10}
//http://192.168.0.200:8092/post/get?title=&type=0&status=-1&date=&author=&serviceItem=&page=1&size=10
export function getPostList(title,type,status,date,author,serviceItem,page,size) {
  const url = HOST + '/home/tieZi/getPostList'
  let data = {
    "title": title,
    "type": type,
    "status": status,
    "date": date,
    "author": author,
    "serviceItem":serviceItem,
    "page": page,
    "size": size,
  }
  return axios.post(url,Qs.stringify(data))
}
export function getMyPostList(title,type,status,date,author,serviceItem,page,size,casAuthorization) {
  const url = HOST + '/home/tieZi/getMyPostList'
  let data = {
    "title": title,
    "type": type,
    "status": status,
    "date": date,
    "author": author,
    "serviceItem":serviceItem,
    "page": page,
    "size": size,
    "casAuthorization": casAuthorization,
  }
  return axios.post(url,Qs.stringify(data))
}


export function getPostDetail(id,page,size,reply,sid) {
  const url = HOST + '/home/tieZi/getPostDetail'
  let data = {
    "id": id,
    "page": page,
    "size": size,
    "reply": reply,
    "sid": sid,
  }
  return axios.post(url,Qs.stringify(data))
}
//获取自己的帖子详情
export function getMyPostDetail(id,page,size,reply) {
  const url = HOST + '/home/tieZi/getMyPostDetail'
  let data = {
    "id": id,
    "page": page,
    "size": size,
    "reply": reply,

  }
  return axios.post(url,Qs.stringify(data))
}

export function addBrowseCount(id,page,size,reply) {
  const url = HOST + '/home/tieZi/addBrowseCount'
  let data = {
    "id": id,
    "page": page,
    "size": size,
    "reply": reply,
  }
  return axios.post(url,Qs.stringify(data))
}
export function commentMinusGreatCount(id) {
  const url = HOST + '/home/tieZi/commentMinusGreatCount'
  let data = {
    "id": id,
  }
  return axios.post(url,Qs.stringify(data))
}
export function commentAddGreatCount(id) {
  const url = HOST + '/home/tieZi/commentAddGreatCount'
  let data = {
    "id": id,
  }
  return axios.post(url,Qs.stringify(data))
}
//帖子点赞
export function addGreatCount(id,page,size,reply) {
  const url = HOST + '/home/tieZi/addGreatCount'
  let data = {
    "id": id,
    "page": page,
    "size": size,
    "reply": reply,
  }
  return axios.post(url,Qs.stringify(data))
}
//帖子点赞取消
export function minusGreatCount(id,page,size,reply) {
  const url = HOST + '/home/tieZi/minusGreatCount'
  let data = {
    "id": id,
    "page": page,
    "size": size,
    "reply": reply,
  }
  return axios.post(url,Qs.stringify(data))
}

export function replyMessage(id,page,size,reply,casAuthorization) {
  const url = HOST + '/home/tieZi/replyMessage'
  let data = {
    "id": id,
    "page": page,
    "size": size,
    "reply": reply,
    "casAuthorization": casAuthorization,
  }
  return axios.post(url,Qs.stringify(data))
}


export function getNewsCategory() {
  const url = HOST + '/home/tieZi/getNewsCategory'
  //const url = HOST + '/category/list'
  return axios.get(url)
}

export function getNews(cid,page,size) {
  const url = HOST + '/home/tieZi/getNews'
  let data = {
    "cid": cid,
    "page": page,
    "size": size,
  }
  return axios.post(url,Qs.stringify(data))
}
export function getNewsById(category,page,size,id) {
  const url = HOST + '/home/tieZi/getNewsById'
  let data = {
    "category": category,
    "page": page,
    "size": size,
    "id": id,
  }
  return axios.post(url,Qs.stringify(data))
}
export function addReadCount(id) {
  const url = HOST + '/home/tieZi/addReadCount'
  let data = {
    "id": id,
  }
  return axios.post(url,Qs.stringify(data))
}





// WEBPACK FOOTER //
// ./src/api/data.js